import React, { useContext } from 'react';
import RoundButton from '../../../components/RoundButton';
import { MODALS } from '../../../constants';
import { Context } from '../../../context/AppContext';
import {
  ListviewEmptySubmarineGraphic,
  ListviewEmptyFishGraphic,
} from '../../../assets/listview';
import './styles.css';

const NoResults = () => {
  const {
    modal: { showModal },
  } = useContext(Context);
  return (
    <div className="Listview__NoResults__root">
      <div className="Listview__NoResults__title">
        Oops, looks like you dove too deep.
      </div>
      <div className="Listview__NoResults__message">
        Your search has not returned any results,
        <br /> so let&apos;s get you back to the surface.
      </div>
      <div className="Listview__NoResults__graphic">
        <img
          src={ListviewEmptySubmarineGraphic}
          className="Listview__NoResults__graphicSubmarine"
          alt=""
        />
        <img
          src={ListviewEmptyFishGraphic}
          className="Listview__NoResults__graphicFish"
          alt=""
        />
        <img
          src={ListviewEmptyFishGraphic}
          className="Listview__NoResults__graphicFish1"
          alt=""
        />
        <img
          src={ListviewEmptyFishGraphic}
          className="Listview__NoResults__graphicFish2"
          alt=""
        />
        <img
          src={ListviewEmptyFishGraphic}
          className="Listview__NoResults__graphicFish3"
          alt=""
        />
      </div>
      <RoundButton
        type="button"
        onClick={() =>
          showModal(MODALS.SEARCH_AUTOSUGGEST, {
            inputFocus: 'keyword',
          })
        }
        theme="outlineBlue"
        hoverIcon="icon-generalarrowesmall"
      >
        Start new search
      </RoundButton>
    </div>
  );
};

export default NoResults;
